import { createRoot } from 'react-dom/client'
import './index.css'
import 'react-international-phone/style.css';
import App from './App'


createRoot(document.getElementById('root')!).render(
  <App />,
)
